var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueTransferIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589417,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#E7F0FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7324_36265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 15.5894H13C12.4 15.5894 12 15.9894 12 16.5894C12 17.1894 12.4 17.5894 13 17.5894H23V20.5894L28 16.5894L23 12.5894V15.5894Z",
    fill: "#86B4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 25.5894H27C27.6 25.5894 28 25.1894 28 24.5894C28 23.9894 27.6 23.5894 27 23.5894H17V20.5894L12 24.5894L17 28.5894V25.5894Z",
    fill: "#86B4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7324_36265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTransferIcon);
export default __webpack_public_path__ + "static/media/blue-transfer-icon.cdbc8d13f883860021b5dea702677534.svg";
export { ForwardRef as ReactComponent };